import { render } from "./PaymentsDetails.vue?vue&type=template&id=124a09d8&scoped=true"
import script from "./PaymentsDetails.vue?vue&type=script&lang=js"
export * from "./PaymentsDetails.vue?vue&type=script&lang=js"

import "./PaymentsDetails.vue?vue&type=style&index=0&id=124a09d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124a09d8"]])

export default __exports__